module.exports = __webpack_public_path__ + "frontend/images/benefits/no-fees.gif?73d46fd7beebbd8c56fe1f890788eac9";